import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgVehiclesIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 20,
	height: 21,
	viewBox: "0 0 20 21",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M13.3334 2.99542H0.833374V13.8288H13.3334V2.99542Z",
			stroke: "currentColor",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M13.3334 7.16208H16.6667L19.1667 9.66208V13.8287H13.3334V7.16208Z",
			stroke: "currentColor",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M4.58333 17.9954C5.73393 17.9954 6.66667 17.0627 6.66667 15.9121C6.66667 14.7615 5.73393 13.8288 4.58333 13.8288C3.43274 13.8288 2.5 14.7615 2.5 15.9121C2.5 17.0627 3.43274 17.9954 4.58333 17.9954Z",
			stroke: "currentColor",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M15.4167 17.9954C16.5673 17.9954 17.5 17.0627 17.5 15.9121C17.5 14.7615 16.5673 13.8288 15.4167 13.8288C14.2661 13.8288 13.3334 14.7615 13.3334 15.9121C13.3334 17.0627 14.2661 17.9954 15.4167 17.9954Z",
			stroke: "currentColor",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})
	]
});
export default SvgVehiclesIcon;
